// Lokaler Zwischenspeicher für das Übergabeformular via IndexedDB.
// Speichert Formularfelder UND Dateien (Fotos, Zähler-Fotos) direkt als Blob/File
// (structured clone unterstützt das), kein Base64-Umweg wie bei localStorage nötig.
//
// Ein Datensatz pro estateId (Key "estate_<id>"), damit mehrere Übergabeformulare
// parallel offen sein können, ohne sich gegenseitig zu überschreiben. Ohne estateId
// (z. B. Formular ohne URL-Parameter aufgerufen) wird der Key "draft" verwendet.

const DB_NAME = "uebergabeFormularCache";
const DB_VERSION = 1;
const STORE_NAME = "formState"; // Object Store (die "Tabelle") innerhalb der Datenbank

function recordKey(estateId) {
   return estateId ? `estate_${estateId}` : "draft";
}

function openDb() {
   return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = () => {
         request.result.createObjectStore(STORE_NAME);
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
   });
}

/** Speichert den übergebenen Formularstand samt Zeitstempel (savedAt, ISO-String) unter dem zur estateId passenden Key. */
export async function saveFormState(data, estateId) {
   const db = await openDb();
   return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      tx.objectStore(STORE_NAME).put({ ...data, savedAt: new Date().toISOString() }, recordKey(estateId));
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
   });
}

/** Liefert den zwischengespeicherten Formularstand (inkl. savedAt) für die estateId oder null, falls keiner vorliegt. */
export async function loadFormState(estateId) {
   const db = await openDb();
   return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readonly");
      const request = tx.objectStore(STORE_NAME).get(recordKey(estateId));
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => reject(request.error);
   });
}

export async function clearFormState(estateId) {
   const db = await openDb();
   return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, "readwrite");
      tx.objectStore(STORE_NAME).delete(recordKey(estateId));
      tx.oncomplete = () => resolve();
      tx.onerror = () => reject(tx.error);
   });
}
